




































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";

//@ts-ignore
import indicador_clasificaciones from '@/mixins/axios/indicador_clasificaciones'
//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: { OrganizationChart },

  data() {
    return {

     indicador_clasificaciones:[] as any,

    };
  },
  mixins: [indicador_clasificaciones],
  methods: {
     onChangeC(event){
//console.log(event.target.value)
this.getDataClasificacion(event.target.value);

},
 async getDataClasificacion(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_CLASIFICACION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_clasificaciones=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
    async onClick() {
      var sTable = document.getElementById("tablaIndicador").innerHTML;
      await axios({
        url: this.$store.state.baseapi + "pdf",
        method: "POST",
        data: {
          html: sTable,
          title: "Ficha Indicador",
        },
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.pdf");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
  },
  created() {},
  mounted() {

       this.getDataClasificacion();
  },
})
export default class Home extends Vue {
  // @Prop() private id !:any;
}
